module.exports = __webpack_public_path__ + "img/X@2x.efff2e1.webp";